import { TextField, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Modal from '@mui/material/Modal'
import { PlayListVisibilityRadioGroup } from 'app/_components/PlayListVisibilityRadioGroup'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { PlaylistVisibilityEnum } from '~/__generated__/graphql'
import { PlayListFormValues } from '~/features/play_list/hooks/usePlayListActionApi'
import { modalStyle, textFiledStyle } from './styles'

interface CreatePlayListModalProps {
  isOpen: boolean
  /** キャンセルボタン押下 */
  onCancel: () => void
  /** 保存ボタン押下 */
  onSave: (values: PlayListFormValues) => void
}

const MAX_TITLE_LENGTH = 150

export const CreatePlayListModal = ({ isOpen, onCancel, onSave }: CreatePlayListModalProps) => {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [visibility, setVisibility] = useState<PlaylistVisibilityEnum>(
    'is_public',
  )
  const { t } = useTranslation()
  const isDisabled = title.length === 0 || title.length > MAX_TITLE_LENGTH

  useEffect(() => {
    if (isOpen) {
      setTitle('')
      setDescription('')
      setVisibility('is_public')
    }
  }, [isOpen])

  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      sx={{ backgroundColor: '#131313CC' }}
    >
      <Box sx={modalStyle}>
        <Typography marginBottom={6} fontSize={24} textAlign='center' fontWeight='bold'>
          {t('new_playlist')}
        </Typography>
        <Box marginBottom={5}>
          <TextField
            label={t('title')}
            variant='standard'
            fullWidth
            sx={textFiledStyle}
            size='medium'
            inputProps={{ style: { fontSize: 24 } }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Box>
        <Box marginBottom={5}>
          <TextField
            label={t('description')}
            variant='standard'
            fullWidth
            sx={textFiledStyle}
            size='medium'
            multiline
            maxRows={6}
            inputProps={{ style: { fontSize: 24, lineHeight: 1.4 } }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Box>
        <Box marginBottom={8} display='flex' justifyContent='center'>
          <PlayListVisibilityRadioGroup value={visibility} onChange={setVisibility} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row' }, gap: 1.5 }}>
          <Button variant='outlined' fullWidth sx={{ borderRadius: 30 }} onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button
            variant='contained'
            fullWidth
            sx={{ borderRadius: 30 }}
            onClick={() => onSave({ title, description, visibility })}
            disabled={isDisabled}
          >
            {t('save')}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}
